module.exports = __webpack_public_path__ + "img/b2cOfficialImgExample.dc34bc76.png";